import gql from "graphql-tag";

export const PAYMENTS_QUERY = gql`
  query paymentsQuery(
    $billingDate_Lte: Date
    $billingDate_Gte: Date
    $paymentStatus: String
    $retries: Int
    $isRecurring: Boolean
  ) {
    payments(
      billingDate_Lte: $billingDate_Lte
      billingDate_Gte: $billingDate_Gte
      paymentStatus: $paymentStatus
      retries_Gte: $retries
      isRecurring: $isRecurring
    ) {
      edges {
        node {
          id
          billingDate
          paymentStatus
          retries
          totalAmount
          discountAmount
          country
          createdAt
          transactionSet {
            id
            transactionStatus
            gatewayResponse
            gatewayReference
          }
          order {
            id
            orderStatus
            package {
              id
              title
            }
            productVariants {
              edges {
                node {
                  id
                  title
                  code
                  product {
                    id
                    title
                    code
                  }
                }
              }
            }
            user {
              id
              firstName
              lastName
              email
              userProfile {
                id
                hubspotContactVid
              }
            }
          }
        }
      }
    }
  }
`;

export const PAYMENTS_PAGINATED_QUERY = gql`
  query paymentsQuery(
    $after: String
    $first: Int
    $billingDate_Lte: Date
    $billingDate_Gte: Date
    $retries: Int
    $isRecurring: Boolean
    $paymentStatus: String
    $discountCodeIcontains: String
    $email: String
    $firstName: String
    $lastName: String
    $country: String
    $order_ProductVariants_ProductId: ID
    $order_ProductVariants_Id: ID
    $acquisitionTypeIn: [String]
    $package: String
  ) {
    payments(
      first: $first
      billingDate_Lte: $billingDate_Lte
      billingDate_Gte: $billingDate_Gte
      retries: $retries
      isRecurring: $isRecurring
      paymentStatus: $paymentStatus
      order_User_Email_Icontains: $email
      order_User_FirstName_Icontains: $firstName
      order_User_LastName_Icontains: $lastName
      country: $country
      order_ProductVariants_ProductId: $order_ProductVariants_ProductId
      order_ProductVariants_Id: $order_ProductVariants_Id
      discounts_Code_Icontains: $discountCodeIcontains
      acquisitionTypeIn: $acquisitionTypeIn
      order_Package_Title_Icontains: $package
      after: $after
    ) {
      pageInfo {
        hasNextPage
        startCursor
        endCursor
      }
      edges {
        node {
          id
          billingDate
          paymentStatus
          retries
          isRecurring
          totalAmount
          discountAmount
          discountCodes
          country
          createdAt
          affiliate {
            id
            code
          }
          subscription {
            id
            acquisitionType
          }
          transactionSet {
            id
            transactionStatus
            gatewayResponse
            gatewayReference
          }
          order {
            id
            orderStatus
            package {
              id
              title
            }
            productVariants {
              edges {
                node {
                  id
                  title
                  code
                  product {
                    id
                    title
                    code
                  }
                }
              }
            }
            user {
              id
              firstName
              lastName
              email
              userProfile {
                id
                phone
                suburb
                country {
                  code
                }
                gymBranch {
                  id
                  title
                }
              }
            }
          }
        }
      }
    }
  }
`;

export const PAYMENT_RECOND_QUERY = gql`
  query paymentsQuery($billingDate_Lte: Date, $billingDate_Gte: Date, $paymentStatus: String) {
    payments(billingDate_Lte: $billingDate_Lte, billingDate_Gte: $billingDate_Gte, paymentStatus: $paymentStatus) {
      edges {
        node {
          id
          billingDate
          paymentStatus
          retries
          totalAmount
          discountAmount
          country
          transactionSet {
            id
            transactionStatus
            gatewayResponse
            gatewayReference
          }
          order {
            id
            orderStatus
            billingDay
            billingOrder {
              edges {
                node {
                  id
                  programStartDate
                  serviceStartDate
                  startDate
                  coach {
                    id
                    firstName
                    lastName
                  }
                }
              }
            }
            user {
              id
              firstName
              lastName
              email
              userProfile {
                id
                hubspotContactId
              }
            }
          }
        }
      }
    }
    shopifyOrders(createdAt_Lte: $billingDate_Lte, createdAt_Gte: $billingDate_Gte) {
      edges {
        node {
          id
          totalPrice
          totalDiscount
          billingCountry
          sku
          subscription {
            id
            startDate
            endDate
            programStartDate
            serviceStartDate
            coach {
              id
              firstName
              lastName
            }
          }
          user {
            id
            firstName
            lastName
            email
            userProfile {
              id
              hubspotContactId
            }
          }
          product {
            id
            type
            programType
          }
        }
      }
    }
  }
`;

export const ALL_PRODUCT_VARIANTS = gql`
  query allProductVariants {
    allProductVariants {
      id
      title
      product {
        id
        title
      }
    }
  }
`;
